<template>
  <div>
    <div class="header">
      <div class="header-logo">
        <img src="~@/assets/imgs/icon/logo.svg" alt="">
      </div>
      <!--左侧账号余额-->
      <div class="header-rt">
        <em v-if="accountInfo" @click="showWalletInfo = true">{{ formatAddress(accountInfo) }}</em>
        <em v-else @click="connectWalletInit">Connect Wallet</em>
      </div>
    </div>
    <!--loading-->
    <div class="open-loading" v-if="tyLoad" style="z-index: 3500">
      <van-loading type="spinner" size="30px">
        {{ tyLoadText }}
      </van-loading>
    </div>

     <!-- 钱包信息弹窗 -->
     <van-popup
      v-model="showWalletInfo"
      position="bottom"
      round
      :style="{ padding: '20px 0 30px 0' }">
      <div class="wallet-info">
        <div class="wallet-title">Connected with <span class="wallet-name">Binance Wallet</span></div>
        
        <div class="wallet-address">
          <div class="address-text">{{ formatAddress(accountInfo) }}</div>
          <div class="copy-icon" :data-clipboard-text="accountInfo" @click="copyAddress">
            <img src="~@/assets/imgs/icon/copy.svg" alt="Copy">
          </div>
        </div>
        
        <div class="disconnect-btn" @click="exitLogin">
          退出连接
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Decimal from 'decimal.js';
import Clipboard from "clipboard";
import {$formatDecimals, $toSmallAddr} from "../../../../util/context";

export default {
  name: "yx_header",
  data() {
    return {
      tyLoad: false,//通用loading
      tyLoadText: false,//通用loading文本
      showWalletInfo: false, // 控制钱包信息弹窗显示
    }
  },
  computed: {
    ...mapState([
      "accountInfo",
      "USDTBalance",
      "WBNBBalance",
    ])
  },
  watch: {
    'accountInfo': {
      async handler() {
        const vm = this
        if (vm.accountInfo) {
          // 获取余额
          await vm.getBalance()
          vm.getTokenPaths()
        }
      },
      immediate: true,
    },
  },
  async created() {
    const vm = this;
    await window.threeKingdoms.init();
    // 自动检测并切换链
    try {
      const currentChainId = await window.web3.eth.getChainId();
      if (currentChainId !== 56) {
        try {
          // 请求切换链
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{chainId: '0x38'}], // BSC 链 ID 56 的十六进制表示
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            try {
              // 若链不存在，请求添加链
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [{
                  chainId: '0x38',
                  chainName: 'Binance Smart Chain Mainnet',
                  nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18
                  },
                  rpcUrls: ['https://bsc-dataseed.binance.org/'],
                  blockExplorerUrls: ['https://bscscan.com/']
                }]
              });
            } catch (addError) {
              console.error('添加链失败', addError);
            }
          } else {
            console.error('切换链失败', switchError);
          }
        }
      }
    } catch (chainError) {
      console.error('获取链 ID 失败', chainError);
    }
    try {
      const accountInfo = await window.threeKingdoms.login();
      vm.$store.commit('setAccountInfo', accountInfo); // 赋值

    } catch (e) {
      console.error('login登录', e);
      vm.$toast({
        message: '沒找到錢包',
        position: 'top',
      });
    }
  },

  methods: {
    // 获取交易路径列表
    getTokenPaths() {
      const vm = this
      vm.$axios.defaults.withCredentials = false;
      vm.$axios.get(`/alpha/users/create/${vm.accountInfo}`)
          .then(function (response) {
          }).catch(error => {
          /// 检查是否有响应数据
        if (error.response && error.response.data) {
          // 从响应数据中获取错误代码
          const errorCode = error.response.data.code;
          if (errorCode === 1010 || errorCode === '1010') {
            vm.$store.commit('isUser', true);
          }
        }
      })
    },
    // 格式化地址显示
    formatAddress(address) {
      if (!address) return '';
      return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    },
    // 复制地址
    copyAddress() {
      const clipboard = new Clipboard('.copy-icon')
      clipboard.on('success', () => {
        this.$toast({
          message: '地址已复制',
          position: 'top',
        })
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$toast({
          message: '不支持复制',
          position: 'top',
        })
        clipboard.destroy()
      })
    },

    async getBalance(){
      const vm = this
      // 代币合约地址
      const USDT_CONTRACT = '0x55d398326f99059fF775485246999027B3197955'; // BSC上的USDT合约地址
      const WBNB_CONTRACT = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'; // BSC上的WBNB合约地址

      // 获取 USDT 余额
      const usdtBalance = await threeKingdoms.getTokenBalance(USDT_CONTRACT, vm.accountInfo);
      // USDT 小数位数为 18
      const usdtDecimals = new Decimal(10).pow(18);
      const formattedUsdtBalance = new Decimal(usdtBalance).div(usdtDecimals).toString();
      console.log('usdtBalance',usdtBalance)
      // 获取 WBNB 余额
      const wbnbBalance = await threeKingdoms.getTokenBalance(WBNB_CONTRACT, vm.accountInfo);
      const wbnbDecimals = new Decimal(10).pow(18);
      const formattedWbnbBalance = new Decimal(wbnbBalance).div(wbnbDecimals).toString();

      // 将余额存储到 Vuex 中
      this.$store.commit('USDTBalance', $formatDecimals(formattedUsdtBalance,2));
      this.$store.commit('WBNBBalance', $formatDecimals(formattedWbnbBalance,2));
    },
    // 退出登陆
    async exitLogin() {
      const vm = this;
      vm.$store.commit('setAccountInfo', '');
      vm.$store.commit('USDTBalance', 0);
      vm.$store.commit('WBNBBalance', 0);
      vm.showWalletInfo = false; // 关闭弹窗
    },
    async loginAccountInfo() {
      try {
        const accountInfo = await window.threeKingdoms.login();
        this.$store.commit('setAccountInfo', accountInfo); // 赋值
      } catch (e) {
        console.error('login登录', e);
        this.$toast({
          message: this.$t("mzdQb"),
          position: 'top',
        });
      }
    },
    async connectWalletInit() {
      const vm = this;
      vm.tyLoad = true;
      vm.tyLoadText = '连接中...';
      try {
        await window.threeKingdoms.init();
        await vm.loginAccountInfo();
        vm.tyLoad = false;
      } catch (e) {
        vm.tyLoad = false;
        console.error('没有该钱包~', e);
        vm.$toast({
          message: '沒有檢測到該錢包',
          position: 'top',
        });
      }
    },
  }
};
</script>
<style lang="scss" type="text/scss" scoped>

.loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: table;
  background-color: rgba(0, 0, 0, .6);
  z-index: 2000;

  .van-loading {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    color: #fff;
  }

  .van-loading__text {
    color: #fff;
  }
}

.header {
  width: 100%;
  max-width: 520px;
  box-sizing: border-box;
  padding: 0 16px;
  height: 44px;
  color: #000;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid transparent;
  transition: border-color 0.3s ease; /* 添加过渡效果 */
  &.with-border {
    border-color: $border;
  }
  .header-logo {

  }

  .header-rt {
    background-color: #000000;
    height: 32px;
    line-height: 32px;
    border-radius: 32px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    padding: 0 15px;
    cursor: pointer;
  }
}

.wallet-info {
  padding: 0 20px;

  .wallet-title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;

    .wallet-name {
      font-weight: bold;
    }
  }

  .wallet-address {
    background-color: $bg;
    border-radius: 12px;
    padding: 15px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .address-text {
      //flex: 1;
      font-size: 20px;
      font-weight: 500;
      padding-right: 10px;
    }

    .copy-icon {
      width: 16px;
      height: 16px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .disconnect-btn {
    background-color: #000;
    color: white;
    text-align: center;
    height: 48px;
    line-height: 48px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
}

@media screen and (min-width: 520px) {
  .header{
    width: 100%;
    max-width: 1920px;
    padding:  0 50px;
    height: 60px;
    .header-rt{
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>